module.exports = __webpack_public_path__ + "media/images/login-new-client-a1f5b0fac3ee26ef774db64ec9bba385.jpg";